export async function askForMediaPermissions () {
  // (taken from WebRTC Samples GitHub)
  console.log('Call getUserMedia() to trigger media permission request.');
  const stream = await navigator.mediaDevices.getUserMedia(
    {'audio': true, 'video': true})
  stream.getTracks().forEach(t=> t.stop())
}
